import _ from 'lodash';
import axios from 'axios';
import Fab from '@mui/material/Fab';
import Box from '@mui/material/Box';
import Loader from 'react-loader-spinner';
import { useHistory } from 'react-router';
import AddIcon from '@mui/icons-material/Add';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState, useCallback } from 'react';

import { classes } from '../styles';
import MuiTable from '../../../components/Dashboard/Common/Table';
import DashboardNavBar from '../../../components/Dashboard/Common/Navbar';
import DashboardSideMenu from '../../../components/Dashboard/Common/SidebarMenu';

const columns = [
  { id: 'no', label: 'No', minWidth: 50, align: 'left' },
  { id: 'title', label: 'Title', minWidth: 350, align: 'left' },
  { id: 'image', label: 'Image URL', minWidth: 300, align: 'left' },
  {
    id: 'excerpt',
    label: 'Excerpt',
    minWidth: 350,
    align: 'left',
  },
  {
    id: 'publishedBy',
    label: 'Published By',
    minWidth: 200,
    align: 'left',
  },
  { id: 'active', label: 'Active', minWidth: 100, align: 'left' },
  { id: 'slug', label: 'Slug', minWidth: 250, align: 'left' },
  { id: 'tags', label: 'Tags', minWidth: 150, align: 'left' },
  {
    id: 'published',
    label: 'Published',
    minWidth: 150,
    align: 'left',
  },
];

const baseUrl = process.env.REACT_APP_BASE_URL;

const DashboardBlogPostsPage = () => {
  const history = useHistory();

  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingError, setLoadingError] = useState(false);

  const handleRowClick = ({ postId }) => {
    history.push(`/dashboard/blog-posts/${postId}`);
  };

  const createData = (
    no,
    title,
    image,
    excerpt,
    publishedBy,
    active,
    slug,
    tags,
    published,
    postId
  ) => ({
    no,
    title,
    image,
    excerpt,
    publishedBy,
    active,
    slug,
    tags,
    published,
    postId,
  });

  const prepareTableRows = useCallback((newPosts) => {
    const rows = [];

    newPosts.forEach((post, index) => {
      rows.push(
        createData(
          index + 1,
          post.title,
          post.image,
          post.excerpt,
          post.createdBy.username,
          post.active ? 'Yes' : 'No',
          post.slug,
          post.tags.length ? post.tags.toString() : '',
          post.createdAt.split('T')[0],
          post._id
        )
      );
    });

    return rows;
  }, []);

  const fetchPosts = useCallback(
    (page, limit) => {
      axios
        .get(`${baseUrl}/blog?page=${page}&limit=${limit}`)
        .then(
          ({
            data: {
              data: { docs = [] },
            },
          }) => {
            if (docs.length) {
              const posts = prepareTableRows(docs);

              setPosts((prevState) => {
                const prevPosts = [...prevState];
                const newPosts = [...posts];

                return _.unionWith(prevPosts, newPosts, _.isEqual);
              });
            } else {
              setPosts([]);
            }

            setLoading(false);
          }
        )
        .catch((err) => {
          console.log('FETCH ERROR: ', err);
          setLoadingError(true);
          setLoading(false);
        });
    },
    [prepareTableRows]
  );

  useEffect(() => {
    fetchPosts(1, 100);
  }, [fetchPosts]);

  return (
    <Box sx={classes.container}>
      <DashboardNavBar />
      <DashboardSideMenu />
      {/* PAGE */}
      <Box sx={classes.pageContainer}>
        {loading ? (
          <Box sx={classes.commonMargin}>
            <Loader type="Oval" color="#B40404" height={80} width={80} />
          </Box>
        ) : loadingError ? (
          <Box sx={classes.commonMargin}>
            <Typography variant="subtitle1" component="div">
              Could not fetch blog posts. Refresh or check back later.
            </Typography>
          </Box>
        ) : (
          <>
            {posts.length ? (
              <MuiTable
                columns={columns}
                rows={posts}
                handleRowClick={handleRowClick}
              />
            ) : (
              <Typography variant="button" component="div" sx={classes.noData}>
                There are no blog posts at the moment. Click on the button below
                to publish a post.
              </Typography>
            )}

            <Fab
              color="primary"
              aria-label="add"
              sx={classes.floatingButton}
              onClick={() => history.push('/dashboard/blog-posts/new')}
            >
              <AddIcon />
            </Fab>
          </>
        )}
      </Box>
    </Box>
  );
};

export default DashboardBlogPostsPage;
